import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegistrationLoading = (isLoading) => ({
  type: actionTypes.SET_REGISTRATION_LOADING,
  payload: isLoading
})
